import { Component, h, Prop, State } from '@stencil/core';
import { generateCssClasses } from '../../utils/generate-css-classes';

@Component({
	shadow: true,
	styleUrl: 'zds-input-counter.scss',
	tag: 'zds-input-counter',
})
export class ZdsInputCounter {
	spanSentinel: HTMLSpanElement;
	componentLength: number;

	@Prop() length: number;
	@Prop() maxlength: number;
	@Prop() showThreshold: number;
	@Prop() warnThreshold: number;

	@State() spanWidth: number = 0;

	componentDidRender(): void {
		if (this.spanWidth === 0 && this.spanSentinel) {
			this.componentLength = this.maxlength;
			const { width } = this.spanSentinel.getBoundingClientRect();
			this.spanWidth = Math.round(width);
		}
	}

	componentWillRender() {
		if (this.maxlength !== this.componentLength) {
			this.spanWidth = 0;
		}
	}

	render() {
		const iconClasses = generateCssClasses('zds-input-counter__counter-icon', {
			warning: this.length >= Math.min(this.warnThreshold, this.maxlength),
			danger: this.length > this.maxlength,
		});

		const wrapperClasses = generateCssClasses('zds-input-counter', {
			visible: this.length >= Math.min(this.showThreshold, this.maxlength),
			warning: this.length >= Math.min(this.warnThreshold, this.maxlength),
		});

		return (
			<div class={wrapperClasses}>
				<zds-icon class={iconClasses} size={4} library="fa-solid" name="triangle-exclamation"></zds-icon>
				<span style={{ minWidth: `${this.spanWidth}px` }} class="zds-input-counter__counter-text">
					{this.length}/{this.maxlength}
				</span>
				{this.spanWidth === 0 ? (
					<span ref={(el) => (this.spanSentinel = el)}>
						{this.maxlength}/{this.maxlength}
					</span>
				) : null}
			</div>
		);
	}
}
